export default __webpack_public_path__ + "static/media/dashbaord_signout.3782cf44.svg";